import React from 'react'
import { FormattedMessage } from 'react-intl'
import { codify } from '../'
import {
    Section, Heading,
    InlineCode, TableColumnHeader, TableRowHeader, TableCell
} from '../s'
import Paragraph from 'components/typography/paragraph'
import { Table, TableHead, TableRow, TableBody } from 'components/table'

const AbsenceSupportedFields = () => (
    <Section>
        <Heading>
            <FormattedMessage
                id="integration_heading_supported_fields"
                defaultMessage="Supported fields" />
        </Heading>
        <Paragraph>
            <FormattedMessage
                id="integration_webhook_preamble_supported_fields_absence"
                defaultMessage="These are the absence fields that the webhook will send updates about:" />
        </Paragraph>
        <Table>
            <TableHead>
                <TableRow>
                    <TableColumnHeader>
                        <FormattedMessage
                            id="noun_field"
                            defaultMessage="Field" />
                    </TableColumnHeader>
                    <TableColumnHeader>
                        <FormattedMessage
                            id="noun_json_key"
                            defaultMessage="JSON key" />
                    </TableColumnHeader>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="integration_webhook_absence_label_id"
                            defaultMessage="The entry’s ID" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>id</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="noun_status"
                            defaultMessage="Status" />
                    </TableRowHeader>
                    <TableCell>
                        <FormattedMessage
                            id="integration_webhook_absence_description_status"
                            defaultMessage="<code>status</code> – one of <code>pending</code>, <code>approved</code>, or <code>rejected</code>."
                            values={{ code: codify }} />
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="noun_type"
                            defaultMessage="Type" />
                    </TableRowHeader>
                    <TableCell>
                        <FormattedMessage
                            id="integration_webhook_absence_description_type"
                            defaultMessage="<code>type</code> – an object containing the field <code>name</code>, with the name of the absence type."
                            values={{ code: codify }} />
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="noun_user"
                            defaultMessage="User" />
                    </TableRowHeader>
                    <TableCell>
                        <FormattedMessage
                            id="integration_webhook_absence_description_user"
                            defaultMessage="<code>user</code> – an object containing the fields <code>id</code> and <code>email</code>, for the user the entry is regarding."
                            values={{ code: codify }} />
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="absence_label_start_date"
                            defaultMessage="Start date" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>startDate</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="absence_label_end_date"
                            defaultMessage="End date" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>endDate</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="absence_label_work_related"
                            defaultMessage="Work related" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>workRelated</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="integration_webhook_absence_label_notes"
                            defaultMessage="Notes added when the entry was registered" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>note</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="integration_webhook_absence_label_comment"
                            defaultMessage="Comment added when the entry was reviewed" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>comment</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="integration_webhook_absence_label_reviewed_at"
                            defaultMessage="The time of the entry’s last review" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>reviewedAt</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="integration_webhook_absence_label_reviewed_by"
                            defaultMessage="The entry’s reviewer" />
                    </TableRowHeader>
                    <TableCell>
                        <FormattedMessage
                            id="integration_webhook_absence_field_description_reviewed_by"
                            defaultMessage="<code>reviewedBy</code> – an object containing the fields <code>id</code> and <code>email</code>, for the last user who reviewed the entry."
                            values={{ code: codify }} />
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="integration_webhook_absence_label_registered_at"
                            defaultMessage="The time of the entry’s registration" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>registeredAt</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="integration_webhook_absence_label_registered_by"
                            defaultMessage="The user who registered the entry" />
                    </TableRowHeader>
                    <TableCell>
                        <FormattedMessage
                            id="integration_webhook_absence_field_description_registered_by"
                            defaultMessage="<code>registeredBy</code> - an object containing the fields <code>id</code> and <code>email</code>, for the user who registered the entry."
                            values={{ code: codify }} />
                    </TableCell>
                </TableRow>
            </TableBody>
        </Table>
    </Section>
)

export default AbsenceSupportedFields